import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import store, { initCrossTabCartSync } from './store/index';
import FaIcon from '@/components/FaIcon.vue';

// Solo JS de Bootstrap; el CSS se importa al inicio de App.vue para que tus overrides vayan después
import 'bootstrap';

// Migración: el carrito ya no se representa como un pedido temporal remoto.
localStorage.removeItem('cart_anonymous_id');

const options = {
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    position: "bottom-right",
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
    maxToasts: 3,
    transition: "Vue-Toastification__fade",
    newestOnTop: true,
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter(
            t => t.content === toast.content
        ).length !== 0) {
            return false;
        }
        return toast;
    }
};

const app = createApp(App);
app.component('FaIcon', FaIcon);
app.use(router);
app.use(store);
app.use(Toast, options);
initCrossTabCartSync(store);
app.mount('#app');

import('@/utils/visitorTracker');
